export default "__VITE_ASSET__CLutizH9__"